import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, ViewController, NavParams, ToastController, LoadingController, Slides } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Http } from '@angular/http';
import { PapaParseService } from 'ngx-papaparse';
import { CalendarModal } from 'ion2-calendar';

import { Activity, User, Project } from 'api/models';

// import { getProject, getProjectMembers } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import * as permissions from '../../services/permissions';
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import {
  analyzeExcelData,
  validateUpdateForErrors,
  addUpdate,
  getAllUpdateData,
  getSubcodesForSelectedTopCode,
  recalculateActivitiesByUser,
  onChangeSelectedActivitySubCode,
  setProject,
  setUserSubCodeSelection,
  setProjectMembers,
  setUpdatePeriodName,
  getAllActivitiesForUser,
  setUpdatePeriodType,
  setDataLookAhead,
  setPlannedEndDate,
  clearUserSubCodeSelections,
  onChangeSelectedActivityCode,
  toggleFilterCode,
  resetAllData
} from '../../services/xer';
import { AuthenticationService } from '../../services/congito';
import { Updates, Projects } from 'api/collections';
const reader = new FileReader()

reader.onerror = (error) => console.log(error)

interface FilterCode {
  actv_code_type_id: number,
    actv_short_len: number,
    seq_num: number,
    actv_code_type: string,
    proj_id: number,
    wbs_id: string,
    actv_code_type_scope: string,
};
type ActivityCode = {
  actv_code_type: string,
  actv_code_type_id: number,
  actv_code_type_scope: string,
  actv_short_len: number,
  proj_id: number,
  seq_num: number,
  wbs_id: string,
};
type P6ImportedProject = {
  proj_id: number,
  proj_short_name: string,
  last_recalc_date: string,
};
type ActivityTask = {
  task_id: number,
  actv_code_type_id: number,
  actv_code_id: number,
  proj_id: number,
};
type datestring = string;
type Task = {
  task_id: number,
  task_type: string, // example: "TT_FinMile"
  task_code: string,
  task_name: string,
  driving_path_flag: 'Y' | 'N',
  early_end_date: datestring,
  proj_id: number,
  status_code: string, // example: "TK_NotStart"
  early_start_date: datestring,
  act_start_date: datestring,
  act_end_date: datestring,
  clndr_id: string,
  wbs_id: number,
  target_drtn_hr_cnt: number,
  total_float_hr_cnt: number,
  remain_drtn_hr_cnt: number,
};

type WBSObject = {
  wbs_id: string,
  parent_wbs_id: string,
  wbs_short_name: string,
};

@Component({
  selector: 'new-update',
  templateUrl: 'new-update.html'
})
export class NewUpdateComponent implements OnInit {
  @ViewChild(Slides) slides: Slides;
  project: Project | void;
  projectMembers: User[];
  xerFileName: string;
  xerLoaded: boolean;
  hasErrors: any[];
  projShortName: string;
  dataDate: Date;
  updatePeriodType: string;
  MAX_NUM_FILTER_CODES = 4;
  isEnabled: boolean;
  disabled: boolean;

  //1d arrays for parent and sub activity codes
  activityTasks: Array < ActivityTask > ;
  taskArray: Array < Task > ;
  projectWbsAccordion: any;
  projectArray: Array < P6ImportedProject > ;
  projectWbsArray: Array < WBSObject > ; //used for re-import wbs code
  calendarArray: Array < { clndr_id: string, day_hr_cnt: number } > ; //used for day hour count
  activityCodesArray: Array < ActivityCode > ; //need to initialize size inside of the callback function
  activitySubCodesArray: any[]; //need to initialize size inside of the callback function

  activitiesByUser: {
    [userId: string]: Array < Partial < Activity >> ,
  };

  possibleLookaheadValues: number[];

  updatePeriodName: string;

  plannedEndDate: Date;
  reminderDate: Date;

  // This is e.g. "30 days", which we parseInt() to get the value.  TODO Should be an array of e.g. { "label": string, "value": number }
  dataLookAhead: string; 


  userSubCodeSelection: Array < {
    userId: string,
    userName: string,
    userSelection: void | {
      actv_code_id: number,
      parent_actv_code_id: string,
      actv_code_type_id: number,
      actv_code_name: string,
      short_name: string,
      seq_num: number,
      color: string,
      total_assignments: number,
    },
  } > ;

  userTotalFloatSelections: Array < {
    userId: string,
    userName: string,
    userFloatSelection: boolean,
  } > ;

  userUpdatePeriodTypeSelections: Array < {
    userId: string,
    userName: string,
    userFloatSelection: boolean,
  } > ;

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~END - GOING TO SERVER~~~~~~~~~~~~~~~~//

  filterCodeOptions: FilterCode[] = [];

  // Selected
  selectedActivityCode: FilterCode;
  selectedFilteringCodes: Array < FilterCode > ;
  totalFloatPermissionUserIdsMap: {
    [key: string]: boolean
  };
  isFirstSlide: boolean;
  isSecondSlide: boolean;
  isLastSlide: boolean;
  subCodes: any[];
  loading: false | 'file' | 'upload' | 'success';

  constructor(
    private _app: App,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private papa: PapaParseService,
    public modalCtrl: ModalController,
    public http: Http,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public httpService: HttpService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService
  ) {
    this.possibleLookaheadValues = [15, 30, 45];
    this.totalFloatPermissionUserIdsMap = {};
    this.selectedFilteringCodes = [];
    this.filterCodeOptions = [];
    this.activitiesByUser = {};
    this.loading = false;
    this.xerLoaded = false;
    this.hasErrors = [];
    this.subCodes = [];
    this.updatePeriodType = "REMAINING_DURATION";
    setUpdatePeriodType(this.updatePeriodType);

  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit(): void {
    resetAllData();
    MeteorObservable.autorun().subscribe(() => {
      const projectId = this.navParams.get('projectId');
      if(!projectId) {
        throw new Error('Missing project id');
      }

      this.project = this.projectService.getProject(projectId);
      this.projectMembers = this.project ? this.projectService.getProjectMembers(this.project) : [];
      setProjectMembers(this.projectMembers);
      setProject(this.project);




    });

    this.isFirstSlide = true;
    this.isLastSlide = false;
    this.isSecondSlide=false;
    reader.onload = this.loadXerFile.bind(this)

    var disabled = false;
  }

  eventHandler(keyCode) {
      if(keyCode == 13) {
        let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }
  slideChanged() {
    this.isFirstSlide = this.slides.isBeginning();
    this.isSecondSlide=this.slides.getActiveIndex()==1;
    this.isLastSlide = this.slides.isEnd();
  }

  validateUpdateForErrors(){
    this.hasErrors = validateUpdateForErrors(addUpdate());
  }

  goToSlideNext() {
    this.slides.slideNext();
  }

  goToSlidePrevious() {
    this.slides.slidePrev();
  }

  clearUserSubCodeSelections() {

    this.userSubCodeSelection=clearUserSubCodeSelections();
  }
  setUpdatePeriodName(){
    setUpdatePeriodName(this.updatePeriodName);
  }

  getSubcodesForSelectedTopCode() {
    this.subCodes= getSubcodesForSelectedTopCode();
  }


  loadXerFile(event){
    const xerFile = event.target.result;
    // console.log("xerFile", xerFile)
    this.userSubCodeSelection = this.projectMembers.map(user => {
      return {
        userId: user._id,
        userName: user.profile.name,
        userSelection: undefined,
      };
    });
    setUserSubCodeSelection(this.userSubCodeSelection);
    this.userTotalFloatSelections = this.projectMembers.map(user => {
      return {
        userId: user._id,
        userName: user.profile.name,
        userFloatSelection: false
      };
    });
    this.loading = 'file';
    // console.log("xerFile", xerFile)

    this.papa.parse(xerFile, {
      header: false,
      dynamicTyping: true,
      complete: (data)=>{
        console.log(data)
        try{
          let analysis = analyzeExcelData(data);
          this.xerLoaded=analysis.xerLoaded;
          this.projectArray=analysis.projectArray;
          this.projectWbsArray=analysis.projectWbsArray;
          this.projectWbsAccordion=analysis.projectWbsAccordion;
          this.calendarArray=analysis.calendarArray;
          this.taskArray=analysis.taskArray;
          this.activityCodesArray=analysis.activityCodesArray;
          this.activitySubCodesArray=analysis.activitySubCodesArray;
          this.activityTasks=analysis.activityTasks;
          this.loading = false;
          this.xerLoaded=true;
        } catch(err){
          this.failedFileUpload(xerFile).bind(this)()
        }
      },
      error: this.failedFileUpload(xerFile).bind(this)
    });
  }
  failedFileUpload(xerFile){
      const a= async function(){
        const loader = this.loadingCtrl.create({
          content: "There was an error processing your file. We are sending it to support for further analysis. Please wait...",
          enableBackdropDismiss: false,
        });
        loader.present();
        const result:any = await new Promise(async (resolve, reject) => {
          try {
            const postData = {
              "metadata": {
                name: (Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5))+`__${this.xerFileName}.xer`,
                type: 'application/octet-stream',
                size: 0
              }
            };
            const options = await this.httpService.getHttpOptions();
            const tempUrlRes: any = await this.httpService.postSls('/tempUrl', postData, options);
            const tempUrl = JSON.parse(tempUrlRes);
            if (tempUrl.isErr === false) {
              const { s3Credentials, filePath } = tempUrl.data;
              const type = 'application/octet-stream';
              const uploadRes = await this.httpService.uploadS3File(s3Credentials, filePath, type, xerFile as any);
              console.log('S3 upload complete');
              const uploadedFile = s3Credentials.split('?')[0];
              const res = {
                status: 200,
                url: uploadedFile
              };
              resolve(res);
            } else {
              console.log('error in temp url POST', tempUrl)
              reject(null);
            }
          } catch (err) {
            console.log('error: upload s3 to presigned url:', err);
            reject(err);
          }
        })
        await this.httpService.MeteorCall(
          'sendContactEmail',
          "XER UPLOAD ERROR",
          result.url
        )
        loader.dismiss();
        const alert = this.alertCtrl.create({
          buttons: ['Refresh website'],
          message: `Thank you for your patience. We will be in touch with you at ${_.get((this.authenticationService.MeteorUser() as User), 'emails[0].address')} to provide manual assistance uploading your file.`,
          title: 'Critical Error: Incompatible P6 file!',
          // ionAlertDidDismiss: 
        });
        alert.present();
        alert.onDidDismiss(()=>{
          location.reload();
        })
      }
      return a.bind(this);
  }

  handleFileSelect(evt): void {
    this.xerLoaded = false;
    const xerFile = evt.target.files[0];
    this.xerFileName = xerFile.name;
    reader.readAsText(xerFile)



  }

  getScheduleId(){
    const projectsByProjectId = this.getProjectsByProjectId();
    const project = projectsByProjectId[Object.keys(projectsByProjectId)[0]]
    return project ? project.proj_short_name : ''
  }

  presentReminderDateModal(): void {
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Reminder Date',
        pickMode: 'single',
        from: new Date(),
        to: this.plannedEndDate,
        closeLabel: 'Cancel',
        doneLabel: 'Done',
      }
    });

    myCalendar.onDidDismiss(date => {
      this.reminderDate = date ? new Date(date.time) : undefined;
    });

    myCalendar.present();
  }

  setUpdatePeriodType(type){
    console.log("setUpdatePeriodType", type)
    setUpdatePeriodType(type);
  }

  presentPlannedEndDateModal(): void {
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Planned End Date',
        pickMode: 'single',
      }
    });

    myCalendar.onDidDismiss(date => {
      this.plannedEndDate = date ? new Date(date.time) : undefined;
      setPlannedEndDate(this.plannedEndDate);
    });

    myCalendar.present();
  }

  getAssignedMembers() {
    const assignedMembers = (this.userSubCodeSelection || []).filter(user => {
      return !!user.userSelection;
    });
    return _.orderBy(assignedMembers, [
      user => this.project && permissions.isProjectManager(this.project, { _id: user.userId }),
      user => user.userName,
    ], ['desc', 'asc']);
  }


  isProjectManager(userId: string): boolean {
    return this.project && permissions.isProjectManager(this.project, { _id: userId });
  }

  isProjectUpdater(userId: string): boolean {
    return this.project && permissions.isProjectUpdater(this.project, { _id: userId });
  }



  getAssignedPMs() {
    return this.getAssignedMembers().filter(user => {
      return this.project && permissions.isProjectManager(this.project, { _id: user.userId });
    });
  }

  getAssignedUpdaters() {
    return this.getAssignedMembers().filter(user => {
      return this.project && !permissions.isProjectManager(this.project, { _id: user.userId });
    });
  }

  onChangeDataLookahead(newVal) {
    setDataLookAhead(newVal)
    this.dataLookAhead=newVal;
    recalculateActivitiesByUser();
  }

  toggleTotalFloatForUser(userId: string) {
    const userHasFloat = !!this.totalFloatPermissionUserIdsMap[userId];
    this.totalFloatPermissionUserIdsMap[userId] = !userHasFloat;
  }

  hasTotalFloatPermission(userId: string): boolean {
    return !!this.totalFloatPermissionUserIdsMap[userId] || this.isProjectManager(userId);
  }


  toggleFilterCode(filterActivityCode) {
    const filterCodeIncluded = _.includes(this.selectedFilteringCodes, filterActivityCode);
    if (filterCodeIncluded) {
      _.remove(this.selectedFilteringCodes, filterActivityCode);
    } else if (this.selectedFilteringCodes.length < this.MAX_NUM_FILTER_CODES) {
      this.selectedFilteringCodes.push(filterActivityCode);
    }
    toggleFilterCode(filterActivityCode);
  }

  isFilterCodeSelected(filterActivityCode) {
    return _.includes(this.selectedFilteringCodes, filterActivityCode);
  }

  aUserHasBeenAssigned(){
    return (this.userSubCodeSelection || []).filter(user => user.userSelection).length;
  }


  onChangeSelectedActivityCode(selectedActivityCode) {
    let codeRes = onChangeSelectedActivityCode(selectedActivityCode)

    this.userSubCodeSelection=clearUserSubCodeSelections();
    this.filterCodeOptions=codeRes.filterCodeOptions;
    this.selectedActivityCode=codeRes.selectedActivityCode;
    this.subCodes=getSubcodesForSelectedTopCode()
  }

  canShowSubCode(code, userObj){
    return !this.userSubCodeSelection.find(user=>user.userSelection && user.userSelection.actv_code_name===code.actv_code_name);
  }

  getNonProjectManagerUserSubCodeSelection(userSubCodeSelection){
    return userSubCodeSelection ? userSubCodeSelection.filter(userObj=>!this.isProjectManager(userObj.userId)) : userSubCodeSelection;
  }

  onChangeSelectedActivitySubCode(selectedActivitySubCode, userObj) {
    this.userSubCodeSelection=this.userSubCodeSelection.map(user=>{
      if(user.userId===userObj.userId) {
        userObj.userSelection = selectedActivitySubCode;
        user.userSelection = selectedActivitySubCode;
        return user;
      } else{
        return user;
      }
    })


    onChangeSelectedActivitySubCode(this.userSubCodeSelection)
    recalculateActivitiesByUser();
  }

  getAllActivitiesForUser(userId: string): Array<Partial<Activity>> {
    let endDate = moment().add(parseInt(this.dataLookAhead), 'days').endOf('day').toDate();
    return getAllActivitiesForUser(userId)
    // .filter(activity=>{
    //   return  moment(activity.taskRow.early_start_date).startOf('day').toDate() < endDate;
    // });
  }

  getNonCriticalActivitiesForUser(userId: string): Array<Partial<Activity>> {
    let endDate = moment().add(parseInt(this.dataLookAhead), 'days').endOf('day').toDate();
    return this.getAllActivitiesForUser(userId).filter(activity => {
      return activity.taskRow.driving_path_flag === 'N'// && moment(activity.taskRow.early_start_date).startOf('day').toDate() < endDate;
    });
  }

  getCriticalActivitiesForUser(userId: string): Array<Partial<Activity>> {

    let endDate = moment().add(parseInt(this.dataLookAhead), 'days').endOf('day').toDate();
    return this.getAllActivitiesForUser(userId).filter(activity => {
      console.log("critical activity",activity, )
      return activity.taskRow.driving_path_flag === 'Y'// && moment(activity.taskRow.early_start_date).startOf('day').toDate() < endDate;
    });
  }

  getRenderedFilterCodes(): Array<void|FilterCode> {
    return _.orderBy(_.times(this.MAX_NUM_FILTER_CODES, i => {
      return this.selectedFilteringCodes[i] || undefined;
    }), 'actv_code_type');
  }

  handleError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }

  getDataDate(): Date {
    if (!this.projectArray) {
      return;
    }
    const lastRecalcDate = this.projectArray[0].last_recalc_date;
    return moment(lastRecalcDate).startOf('day').toDate(); // probably YYYY-MM-DD time-something?
  }


  getProjectsByProjectId() {
    return _.keyBy(this.projectArray, project => project.proj_id);
  }

  presentLoading() {

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: false,
    });
    loader.present();
    return loader;
  }
    disablebtn(){

    this.isEnabled = true;
    }
    onChange(ev: any) {
    // if(this.isDev == true) {   console.log('Changed', ev); }
    }

  async addUpdate(): Promise<any> {

  this.disablebtn()
  const loader = this.presentLoading()

    let update = addUpdate();



    if(update['projectId']){
      /*
      MeteorObservable.call('addUpdate', update, {
        ...getAllUpdateData(),
        xerFileName: this.xerFileName
      }).subscribe({
        next: () => {
          loader.dismiss()
          this.loading = 'success';
          this.viewCtrl.dismiss();

        },
        error: (e: Error) => {
          loader.dismiss()
          this.handleError(e);
          this.loading = false;
        }
      });
      */
     const updateUpload:any = await new Promise(async (resolve, reject) => {
      try {
        const postData = {
          "metadata": {
            name: update['updateName'],
            type: 'application/json',
            size: 0
          }
        };
        const options = await this.httpService.getHttpOptions();
        const tempUrlRes: any = await this.httpService.postSls('/tempUrl', postData, options);
        const tempUrl = JSON.parse(tempUrlRes);
        if (tempUrl.isErr === false) {
          const { s3Credentials, filePath } = tempUrl.data;
          const type = 'application/json';
          const uploadRes = await this.httpService.uploadS3File(s3Credentials, filePath, type, JSON.stringify({
            update,
            updateMetaData: {
              ...getAllUpdateData(),
              xerFileName: this.xerFileName
            }
          }) as any);
          console.log('S3 upload complete');
          const uploadedFile = s3Credentials.split('?')[0];
          const res = {
            status: 200,
            url: uploadedFile
          };
          resolve(res);
        } else {
          console.log('error in temp url POST', tempUrl)
          reject(null);
        }
      } catch (err) {
        console.log('error: upload s3 to presigned url:', err);
        reject(err);
      }
    })
    console.log("updateUploadupdateUploadupdateUpload", updateUpload)


      this.httpService.MeteorCall('addUpdate', updateUpload.url


      // update, {
      //   ...getAllUpdateData(),
      //   xerFileName: this.xerFileName
      // }
      )
      .then(() => {

        
        console.log("uuuupupupupupuuupu update added")
        loader.dismiss()
        this.loading = 'success';
        this.viewCtrl.dismiss();
      })
      .catch((e: Error) => {
        loader.dismiss()
        this.handleError(e);
        this.loading = false;
      });
    } else {
      loader.dismiss()
      const alert = this.alertCtrl.create({
        buttons: ['OK'],
        message: update['message'],
        title: 'Oops!'
      });

        this.disabled = false;
       this.isEnabled = false;
      alert.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-update/new-update.ts